import React,{useState, useEffect} from "react";
import {useNavigate, useParams } from "react-router-dom";
import LoginBanner from '../images/loginbg.png';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import LangSwitcher from './common/LanguageSwitcher';
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useFormik} from "formik";
import axios from "axios";
import swal from "sweetalert";


function Login(props) {
    let { token } = useParams();
    
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const togglePassword =()=>{

        if(passwordType==="password")
        {
         setPasswordType("text")
        
        }else{
          setPasswordType("password")
        }
      }

    const [passwordType, setPasswordType] = useState("password");
    const [comPasswordType, setComPasswordType] = useState("password");
   
      const handleShowPassword = () => {
        
        if (passwordType === "password") setPasswordType("text");
        else setPasswordType("password");
      };
      const handleConfirmShowPassword = () => {
        
        if (comPasswordType === "password") setComPasswordType("text");
        else setComPasswordType("password");
      };

    const backAction = () => {
        navigate("/");
    }

    useEffect(()=>{      
      checkToken()
    },[]);

    const checkToken = () => {
      axios.post(process.env.REACT_APP_API_KEY+"api/tokenvalid/"+token, {headers: {
        "Content-type": "Application/json",
        "sellang": localStorage.getItem("selectLang")
        }   
        })
      .then((res) => {
        if (res.data.status === true) {
          //
        } else {
          swal("Oops", res.data.message, "error").then(function () {
            navigate("/");
          });
        }
        
      }).catch(error => {
        swal("Oops", "Unauthorized User", "error");
      })

    }
    const validationSchema = Yup.object().shape({
        password: Yup.string().required(t('validation_empty_error'))
        .min(6, t('validation_pass_min'))
        .max(40, t('validation_pass_max')),
        confirm_password: Yup.string().required(t('validation_empty_error')).when("password", {
          is: val => (val && val.length > 0 ? true : false),
          then: Yup.string().oneOf(
            [Yup.ref("password")],
            t('validation_pass_match')
          )
        })
      });
      
    
    const formik = useFormik({
        initialValues: {
          password: "",
          confirm_password: "",
        },
        validationSchema,       
        onSubmit: async (data) => {
           console.log('input data')
          await axios       
            .post(process.env.REACT_APP_API_KEY+"api/reset-password/"+token, data, {headers: {
              "Content-type": "Application/json",
              "sellang": localStorage.getItem("selectLang")
              }   
              })
            .then((res) => {
              if (res.data.status === true) {
                 swal({
                   title: "Wow!",
                   text: res.data.message,
                   icon: "success",
                   button: "Okay",
                 }).then(function () {
                  navigate("/");
                });;
                
              } else {
                swal("Oops", res.data.message, "error");
              }
              //console.log(res.data.message);
            }).catch(error => {
              swal("Oops", "Unauthorized User", "error");
              console.log('aya',error.response);
          });
         // console.log(JSON.stringify(data, null, 2));
    
        },
      });
    
    return (
        <>
            <div className="login">
            <div className="d-flex flex-column-reverse flex-md-row">
            <div className="w-100 w-md-40">
                    <div className="login-form-container">
                    <div className="position-relative main-left-form">
                        <div className="login-head">
                        <LangSwitcher/>
                        </div>
                        <div className="login-form-head"> 
                            <div className="form-heading">
                                <h3>{t('reset_heading1')}</h3>
                            </div>
                        </div>
                        <div className="login-form"> 
                            <div className="main-form">
                                <div>
                                <form className="row g-3" onSubmit={formik.handleSubmit}>
                                        
                                        <Form.Group className="" controlId="password">
                                             <Form.Label>{t('reset_new_pass')}<span className="text-danger">*</span></Form.Label>
                                             <div className="icon-input">
                                                <Form.Control type={passwordType} name = "password" onBlur = {formik.handleBlur} onChange={formik.handleChange} placeholder="" autoComplete="off"  />
                                                <span
                                                        style={{ cursor: "pointer" }}
                                                        className="field_icon toggle-password"
                                                        onClick={handleShowPassword}
                                                    ><i className={ passwordType==='password'? `fa fa-eye`: `fa fa-eye-slash`}  aria-hidden="true" onClick={togglePassword} /></span>
                                            </div>
                                        </Form.Group>
                                        <div className="text-danger">
                                          {formik.errors.password ? formik.errors.password : null}
                                        </div>
                                        <Form.Group className="mb-3" controlId="confirm_password">
                                             <Form.Label>{t('reset_con_pass')}<span className="text-danger">*</span></Form.Label>
                                             <div className="icon-input">
                                             <Form.Control type={comPasswordType} name ="confirm_password" onBlur = {formik.handleBlur} onChange={formik.handleChange} placeholder="" />
                                             <span
                                                        style={{ cursor: "pointer" }}
                                                        className="field_icon toggle-password"
                                                        onClick={handleConfirmShowPassword}
                                                    ><i className={ comPasswordType==='password'? `fa fa-eye`: `fa fa-eye-slash`}  aria-hidden="true" /></span>
                                            
                                            </div>
                                        </Form.Group>
                                        <div className="text-danger">
                                            {formik.errors.confirm_password ? formik.errors.confirm_password : null}
                                        </div>
                                        <div className="login-btn-box d-flex">
                                        <button type="button" onClick={backAction} className="btn btn-red-bg btn-md nav-btn fill back-btn">{t('reset_button_back')}</button>
                                        <button type="submit" className="btn btn-red-bg btn-md nav-btn02 fill02">{t('reset_button_submit')}</button>
                                        
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                    <div className="w-100 w-md-60">
                    <div className="right-box">
                        <img src={LoginBanner} alt="" className="img-fluid login-bg"/>
                        <div className="banner-text px-4">
                            <div>
                            <p id="welcome">{t('forgot_welcome')}</p>
                            <p>{t('forgot_msg')}</p>
                            <div id="line"></div>
                            <span>{t('forgot_line_msg')}</span>
                            </div>
                        </div>
                    </div>
                    </div>
                    </div>
                </div>
            
              
        </>
    );
}

export default Login;
